import script from "./MessageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDialog.vue?vue&type=script&setup=true&lang=js"

import "./MessageDialog.vue?vue&type=style&index=0&id=82f0fde4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f0fde4"]])

export default __exports__